export const BarChartImg = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="11" y="12" width="6" height="40" rx="1" fill="#DFECFF" />
    <rect x="11" y="20" width="6" height="32" rx="1" fill="#1E78FF" />
    <rect x="20" y="18" width="6" height="34" rx="1" fill="#DFECFF" />
    <rect x="20" y="25" width="6" height="27" rx="1" fill="#1E78FF" />
    <rect x="29" y="25" width="6" height="27" rx="1" fill="#DFECFF" />
    <rect x="38" y="29" width="6" height="23" rx="1" fill="#DFECFF" />
    <rect x="47" y="35" width="6" height="17" rx="1" fill="#DFECFF" />
    <rect x="29" y="31" width="6" height="21" rx="1" fill="#1E78FF" />
    <rect x="38" y="35" width="6" height="17" rx="1" fill="#1E78FF" />
    <rect x="47" y="41" width="6" height="11" rx="1" fill="#1E78FF" />
  </svg>
);
